import React, { useContext } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';

const CreateQuoteCurrencyCell = ({
    name = '',
    value = 0
}) => {
    const { formatCurrency } = useContext(SystemSettingsContext);

    const textStyle = {
        fontSize: 12,
        margin: '0 2px',
        boxSizing: 'border-box'
    };

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '110px max-content minmax(max-content,auto)' }}>
            <span style={textStyle}>{name}</span>
            <span style={textStyle}>:</span>
            <span style={textStyle}>{formatCurrency(value)}</span>
        </div>
    );
}

export default CreateQuoteCurrencyCell;
